import React from 'react';

function IdPassportIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="5.5"
        width="21.9231"
        height="15"
        rx="2"
        stroke="#282828"
        strokeWidth="1.2"
      />
      <path
        d="M12.5139 10.1156H20.5908"
        stroke="#282828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5139 12.4232H20.5908"
        stroke="#282828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5139 14.7308H20.5908"
        stroke="#282828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="7.08233"
        cy="11.5607"
        rx="3.05913"
        ry="3.17596"
        stroke="#282828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9615 20.5002C11.2808 16.8757 9.33653 14.731 7.08941 14.731C4.8423 14.731 2.87499 16.8411 2.17114 20.4079"
        stroke="#282828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IdPassportIcon;
